import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import CybsIcon from '@cybs-ui/components/lib/icon'
import {replaceSpace, setWindowLocationHash} from '../../../../../../src/libs/common-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {getFirstLevelKey, getSecondLevelKey, getThirdLevelKey} from '../../../reducers/examples-reducer';
import {getDescriptionExpansionAlertFlag} from '../../../reducers/rhs-schema-reducer';
import '../css/descriptions.css';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import {getPartnerFullName } from '../../../../../lhs/reducers/configuration-reducer';

const renderer = new marked.Renderer();

renderer.heading = (text, level) => {
    return `<h${level} style="margin-left:20px">
              ${text}
            </h${level}>`
  };

renderer.paragraph = (text) => {
    return `<p style="margin-left:20px">
              ${text}
            </p>`
  }

marked.setOptions({
    renderer
});

class Descriptions extends React.Component{

    
    
    render(){

        const children = this.props.jsTree;
        const displayType = this.props.display;
        const parent = this.props.parent;
        const partnerFullName = getPartnerFullName().length > 0 ? getPartnerFullName() : 'Cybersource';
        var isExpanded = false;
        var urlHash = "";
        if(this.props.jsTree == undefined || this.props.jsTree.length == 0){
            return(
                <div></div>
            )
        }
        else{
            return (
                <div className={this.props.type + '-' + parent} style={{  display: displayType}}>
                  {children.map(comment =>
                    <div className='descriptions'>
                      <div id = {'hierarchy-' + this.props.type + '-' + comment.value} style={{marginLeft:'10px'}}>
                        <div key={comment.value} id={this.props.type + '-' + comment.value} style={{margin:'5px', marginLeft: '15px'}}>
                        {
                          comment.children &&
                          <span>
                            <div 
                              id = {'btn-show-' + this.props.type + '-' + comment.value} 
                              onClick={() => {
                                  document.getElementById('span-show-' + this.props.type + '-' + comment.value).setAttribute('aria-expanded', true);
                                  var elems = document.querySelectorAll("[class='" + this.props.type + '-' + comment.value + "']")
                                  for (var i = 0; i < elems.length; i++) {
                                      elems[i].style.display = "block";
                                  }
                                  isExpanded = !isExpanded;
                                  if(this.props.type == 'requestexpanded'){
                                    var expandedFlag = getDescriptionExpansionAlertFlag();
                                    if(expandedFlag == undefined){
                                      expandedFlag = false;
                                    }
                                    putDataInDevCenterDataStore({type: 'UPDATE_DESCRIPTION_EXPANSION_ALERT_FLAG', descriptionExpansionAlertFlag: !expandedFlag})
                                  }
                                  document.getElementById('hierarchy-' + this.props.type + '-' + comment.value).style.borderLeft = '1px solid rgb(217,217,214)';
                                  var showButton = document.getElementById('btn-show-' + this.props.type + '-' + comment.value);
                                  var hideButton = document.getElementById('btn-hide-' + this.props.type + '-' + comment.value);
                                  showButton.style.display = 'none';
                                  hideButton.style.display = 'inline-block';
                                  urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_","-") +"_" + replaceSpace(getSecondLevelKey()).replaceAll("_","-") +"_"+ replaceSpace(getThirdLevelKey()).replaceAll("_","-")+"_" + this.props.type +"fielddescription_" + comment.value.replaceAll("-","_");
                                  setWindowLocationHash(urlHash.replace(/-_/g,"_"));
                                }}
                              style={{marginRight:'10px', cursor:'pointer', display:'inline-block'}}
                            >
                              <FontAwesomeIcon icon={faChevronDown} size="xs"/>
                            </div>
                          <div 
                            id = {'btn-hide-' + this.props.type + '-' + comment.value} 
                            onClick={() => {
                                  document.getElementById('span-show-' + this.props.type + '-' + comment.value).setAttribute('aria-expanded', false);
                                  var elems = document.querySelectorAll("[class='" + this.props.type + '-' + comment.value + "']")
                                  for (var i = 0; i < elems.length; i++) {
                                      elems[i].style.display = "none";
                                  }
                                  isExpanded = !isExpanded;
                                  if(this.props.type == 'requestexpanded'){
                                    var expandedFlag = getDescriptionExpansionAlertFlag();
                                    if(expandedFlag == undefined){
                                      expandedFlag = false;
                                    }
                                    putDataInDevCenterDataStore({type: 'UPDATE_DESCRIPTION_EXPANSION_ALERT_FLAG', descriptionExpansionAlertFlag: !expandedFlag})
                                  }
                                  document.getElementById('hierarchy-' + this.props.type + '-' + comment.value).style.borderLeft = 'unset';
                                  var showButton = document.getElementById('btn-show-' + this.props.type + '-' + comment.value);
                                  var hideButton = document.getElementById('btn-hide-' + this.props.type + '-' + comment.value);
                                  showButton.style.display = 'inline-block';
                                  hideButton.style.display = 'none';
                                  urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_","-") +"_" + replaceSpace(getSecondLevelKey()).replaceAll("_","-") +"_"+ replaceSpace(getThirdLevelKey()).replaceAll("_","-")+"_" + this.props.type +"fielddescription_" + comment.value.replaceAll("-","_");
                                  setWindowLocationHash(urlHash.replace(/-_/g,"_"));
                              }}
                            style={{display:'none', marginRight:'10px',cursor:'pointer'}}
                          >
                            <FontAwesomeIcon icon={faChevronUp} size="xs"/>
                          </div>
                          </span>
                        }
                        {comment.children && <span id = {'span-show-' + this.props.type + '-' + comment.value} aria-expanded= { isExpanded } role="button" class = 'descriptionsLabel' tabIndex = "1" dataTest="object" onClick={() => {
                                  urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_","-") +"_" + replaceSpace(getSecondLevelKey()).replaceAll("_","-") +"_"+ replaceSpace(getThirdLevelKey()).replaceAll("_","-")+"_" + this.props.type +"fielddescription_" + comment.value.replaceAll("-","_");
                                  
                                  setWindowLocationHash(urlHash.replace(/-_/g,"_"));
                                  if(!isExpanded){
                                    document.getElementById('span-show-' + this.props.type + '-' + comment.value).setAttribute('aria-expanded', true);
                                    var elems = document.querySelectorAll("[class='" + this.props.type + '-' + comment.value + "']")
                                    for (var i = 0; i < elems.length; i++) {
                                        elems[i].style.display = "block";
                                    }
                                    isExpanded = !isExpanded;

                                    document.getElementById('hierarchy-' + this.props.type + '-' + comment.value).style.borderLeft = '1px solid rgb(217,217,214)';
                                    var showButton = document.getElementById('btn-show-' + this.props.type + '-' + comment.value);
                                    var hideButton = document.getElementById('btn-hide-' + this.props.type + '-' + comment.value);
                                    showButton.style.display = 'none';
                                    hideButton.style.display = 'inline-block';
                                  }
                                  else{
                                    document.getElementById('span-show-' + this.props.type + '-' + comment.value).setAttribute('aria-expanded', false);
                                    var elems = document.querySelectorAll("[class='" + this.props.type + '-' + comment.value + "']")
                                    for (var i = 0; i < elems.length; i++) {
                                        elems[i].style.display = "none";
                                    }
                                    isExpanded = !isExpanded;

                                    document.getElementById('hierarchy-' + this.props.type + '-' + comment.value).style.borderLeft = 'unset';
                                    var showButton = document.getElementById('btn-show-' + this.props.type + '-' + comment.value);
                                    var hideButton = document.getElementById('btn-hide-' + this.props.type + '-' + comment.value);
                                    showButton.style.display = 'inline-block';
                                    hideButton.style.display = 'none';
                                  }
                                  
                                  }}>{(typeof comment.label == 'string')?comment.label:comment.label.props.children[0]}
                        </span>}
                        {comment.children == undefined && <span id = {'span-show-' + this.props.type + '-' + comment.value} role="button" class = 'descriptionsLabel' tabIndex = "1" dataTest="nonobject" style = {{marginLeft: "19.19px"}} onClick={() => {
                                  urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_","-") +"_" + replaceSpace(getSecondLevelKey()).replaceAll("_","-") +"_"+ replaceSpace(getThirdLevelKey()).replaceAll("_","-")+"_" + this.props.type +"fielddescription_" + comment.value.replaceAll("-","_");
                                  setWindowLocationHash(urlHash.replace(/-_/g,"_"));
                                  }}>{(typeof comment.label == 'string')?comment.label:comment.label.props.children[0]}
                        </span>}
                        {comment.additionalInformation && <span onClick={() => {
                           putDataInDevCenterDataStore({type: 'UPDATE_NODE_CLICK_CHECK', nodeClickCheck: true})
                           putDataInDevCenterDataStore({type: 'UPDATE_CLICKED_NODE', clickedNode: this.props.type+'-body-'+comment.value})
                        }}><CybsIcon name='info' resolution='tiny' dataTest='info'/></span>}
                        <br />
                        {comment.type && <span style={{marginLeft:'20px'}}><span style={{fontWeight:'bold'}}>{'Type  '}</span>{comment.type}</span>}
                        {
                          comment.minLength &&
                          <span style={{marginLeft:'20px'}}><span style={{fontWeight:'bold'}}>{'MinLength  '}</span>{comment.minLength}</span>
                        }
                        {
                          comment.maxLength &&
                          <span style={{marginLeft:'20px'}}><span style={{fontWeight:'bold'}}>{'MaxLength  '}</span>{comment.maxLength}</span>
                        }
                        {
                          comment.pattern &&
                          <span style={{marginLeft:'20px'}}><span style={{fontWeight:'bold'}}>{'Pattern  '}</span>{comment.pattern}</span>
                        }
                        {
                          comment.className == "custom-required" &&
                          <span style={{marginLeft:'20px'}}><span class="required-description">Required</span></span>
                        }
                        {
                          comment.className == "required" &&
                          <span style={{marginLeft:'20px'}}><span style={{fontWeight:'bold', color:'red'}}>Required</span></span>
                        }
                        {comment.type && <br />}
                       <span dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked(comment.description==undefined?"":comment.description.replaceAll(/Cybersource/ig, partnerFullName)))}}></span>
                        <hr color="#F4F4F4" style={{margin: '0px'}} />
                        {comment.children && <Descriptions jsTree={comment.children} display="none" parent={comment.value} type={this.props.type}/>}
                      </div>
                      </div>
                    </div>
                  )}
                </div>
              )
          

        }
        
        }
}
    

export default Descriptions;
  
